import { requestFunctionJson } from '../api/functionsTransport';

/** Mirrors functions/src/services/sheets/types.ts. */
export type SyncTabKey =
    | 'events'
    | 'maintenanceTasks'
    | 'donations'
    | 'monkVisits'
    | 'vasTeams'
    | 'vasBudget'
    | 'bookings'
    | 'donationRequests';

export interface TabSyncResult {
    tab: SyncTabKey;
    created: number;
    updatedInApp: number;
    updatedInSheet: number;
    addedToSheet: number;
    deletedFromApp: number;
    deletedFromSheet: number;
    conflicts: number;
    skipped: { row: number; reason: string }[];
    error?: string;
}

export interface SyncRunResult {
    year: number;
    spreadsheetId: string;
    tabs: TabSyncResult[];
    startedAt: string;
    finishedAt: string;
    ok: boolean;
}

export interface SheetSyncConfig {
    year: number;
    spreadsheetId: string;
    enabled: boolean;
    tabs?: SyncTabKey[];
}

/**
 * The sync endpoints are `onRequest` functions guarded by `verifyAdminAuth`,
 * which enforces the admin allow-list *and* the TOTP claim server-side. That is
 * why we send the ID token. Browser calls go through Firebase Hosting rewrites
 * so the app does not need cross-origin Cloud Functions requests.
 */
export const fetchSheetSyncStatus = (year: number) =>
    requestFunctionJson<{ success: boolean; config: SheetSyncConfig; availableTabs: SyncTabKey[] }>(
        `getSheetSyncStatus?year=${year}`,
        { auth: 'current-user' },
    );

export const saveSheetSyncConfig = (config: SheetSyncConfig) =>
    requestFunctionJson<{ success: boolean; spreadsheetId: string }>('saveSheetSyncConfig', {
        method: 'POST',
        auth: 'current-user',
        body: config,
    });

export const runSheetSync = (year: number, tabs?: SyncTabKey[]) =>
    requestFunctionJson<{ success: boolean; result: SyncRunResult }>('syncSheetNow', {
        method: 'POST',
        auth: 'current-user',
        body: { year, tabs },
        acceptedStatuses: [207],
    });
